const fleetManagementSections = {
  DEVICES: "devices",
  FWU_CAMPAIGNS: "fwuCampaigns",
  FIRMWARES: "firmwares"
};

export default fleetManagementSections;
